<template>

  <div
    class="list-group-item list-group-item-action"
    @click="setCandidate(candidate.candidate_id)"
    style="cursor: pointer;">
    <div class="p-2">
      <div class="candidate-item">
        <div>
          <div>
            <h5 class="mb-1">
              <a
                href="javascript:void(0)"
                @click="setCandidate(candidate.candidate_id)"
                style="color: inherit;">
                {{ candidate.name }}
              </a>
            </h5>
            <p><b>{{ candidate.subareas_or_technologies.join(', ') }}.</b><br>{{ candidate.work_location.join(', ') }}</p>
            <div class="skills mb-3">
              <span
                v-for="(skill) in Object.entries(candidate.skills)"
                class="alert"
                :class="{'alert-success': skill[1] === 3, 'alert-primary': skill[1] === 2, 'alert-secondary': skill[1] === 1}">{{ skill[0] }}</span>
            </div>
          </div>
          <div>
            Idiomas: {{ candidate.languages.join(', ') }}.<br>
            Contratação: CLT ({{ candidate.contract_type.CLT }}), PJ ({{ candidate.contract_type.PJ }})
          </div>
        </div>
        <div class="actions">
          <div
            v-if="tab === 'match'"
            style="margin: 0 auto"
            class="circle mb-2"
            :class="{'circle-success': candidate.percentage >= 80, 'circle-primary': candidate.percentage < 80 && candidate.percentage >= 70, 'circle-warning': candidate.percentage < 70}"
            :style="{'--percentage': candidate.percentage}">
            <div class="circle-content">
              {{ candidate.percentage }}%
            </div>
          </div>

          <!-- <button
            v-if="!candidate.accessible && !candidate.invite && !candidate.applied"
            type="button"
            class="btn btn-outline-secondary"
            @click="changeStatus('invited', candidate.candidate_id)">
            <i class="fa-solid fa-check"></i>
            Abordar
          </button> -->

          <!-- <button
            v-if="!candidate.accessible && candidate.applied"
            type="button"
            class="btn btn-outline-secondary"
            @click="changeStatus('contact', candidate.candidate_id)">
            <i class="fa-solid fa-check"></i>
            Contatar
          </button> -->

          <!-- <button
            v-if="candidate.invite"
            type="button"
            class="btn btn-outline-secondary disabled"
            @click="changeStatus('invited', candidate.candidate_id)">
            Abordado
          </button> -->
          
          <div
            v-if="['considered', 'disregarded'].includes(tab)"
            class="btn-group" role="group" aria-label="Basic example">
            <button
              type="button"
              class="btn"
              @click="candidate.disregarded = false"
              :class="{ 'btn-outline-secondary': candidate.disregarded, 'btn-success': !candidate.disregarded }">
              <i class="fa-solid fa-thumbs-up"></i>
            </button>
            <button
              type="button"
              class="btn"
              @click="candidate.disregarded = true"
              :class="{ 'btn-outline-secondary': !candidate.disregarded, 'btn-danger': candidate.disregarded }">
              <i class="fa-solid fa-thumbs-down"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'RhevolutJobItem',
  components: {
  },
  props: {
    candidate: {
      type: Object,
      value: () => { return {} }
    },
    tab: {
      type: String,
      value: null
    },
    percentage: {
      type: Number,
      value: 0
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    setCandidate (id) {
      this.$emit('select', id)
    },
    changeStatus (status, id) {
      this.$emit('changeStatus', { id, status })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.skills {
  display: flex;
  flex-wrap: wrap;
}
.skills > * {
  margin: 0.1em;
  padding: 0.3em 0.8em;
  border-radius: 2em;
}

.candidate-item {
  display: flex;
  justify-content: space-between;
}
  .candidate-item > * {
  }
  .candidate-item > *.actions {
    text-align: center;
  }
.circle {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1em;
  color: #333;
}
  .circle::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: conic-gradient(#28a745 calc(var(--percentage) * 1%), #ddd calc(var(--percentage) * 1%));
    -webkit-mask: radial-gradient(circle, transparent 52%, white 53%);
            mask: radial-gradient(circle, transparent 52%, white 53%);
  }
  .circle.circle-success::before {
    background: conic-gradient(#28a745 calc(var(--percentage) * 1%), #ddd calc(var(--percentage) * 1%));
  }
  .circle.circle-primary::before {
    background: conic-gradient(#007bff calc(var(--percentage) * 1%), #ddd calc(var(--percentage) * 1%));
  }
  .circle.circle-warning::before {
    background: conic-gradient(#ffc107 calc(var(--percentage) * 1%), #ddd calc(var(--percentage) * 1%)) !important;
  }
  .circle-content {
    position: relative;
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/RhevolutJob/RhevolutJobItem.vue